import { useMemo } from 'react';

import { meshModules } from 'Deer/constants/modules';
import { L3_PATHS } from 'Deer/constants/routes';
import { useRouteToNavLevels } from 'Deer/hooks/useRouteToL3';
import { IntentFilters } from 'Deer/intent/components/Layout/IntentFilters.layout';
import type { IntentBreadcrumbType } from 'Deer/intent/types/IntentCommonTypes';
import { useHistory, useLocation } from 'react-router-dom';

type CheckInsIntentDropdownProps = {
  breadcrumbs: IntentBreadcrumbType;
  MetaFilter: React.ReactNode;
};

export const CheckInsIntentDropdown = ({ breadcrumbs, MetaFilter }: CheckInsIntentDropdownProps) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { l1Module } = useRouteToNavLevels();

  const CHECK_INS_INTENT_DROPDOWN_OPTIONS = useMemo(
    () => [
      {
        label: 'I want to share my next check-in',
        visible: () => true,
        onClick: () => {
          history.push(L3_PATHS['my-data'].checkIns.nextCheckIns);
        },
        category: 'NEXT CHECK-INS',
        value: {
          myData: {
            path: L3_PATHS['my-data'].checkIns.nextCheckIns,
          },
        },
      },
      {
        label: 'I want to see my past check-ins',
        visible: () => true,
        onClick: () => {
          history.push(L3_PATHS['my-data'].checkIns.pastCheckIns);
        },
        category: 'PAST CHECK-INS',
        value: {
          myData: {
            path: L3_PATHS['my-data'].checkIns.pastCheckIns,
          },
        },
      },
    ],
    [history]
  );

  const selectedIntent = useMemo(
    () => CHECK_INS_INTENT_DROPDOWN_OPTIONS.find((option) => pathname.includes(option.value[l1Module].path)),
    [CHECK_INS_INTENT_DROPDOWN_OPTIONS, l1Module, pathname]
  );

  return (
    <IntentFilters
      intentDropdownOptions={CHECK_INS_INTENT_DROPDOWN_OPTIONS}
      selectedIntent={selectedIntent?.label ?? ''}
      selectedIntentId={selectedIntent?.id ?? ''}
      breadcrumbs={breadcrumbs}
      moduleName={meshModules.checkIns.value}
      intentTitle={meshModules.checkIns.label}
      isCategorized
      MetaFilters={MetaFilter}
    />
  );
};
